<template>
 <v-container fluid grid-list-md>
  <v-layout row wrap>
   <v-flex>
    <Card>
     <v-card-title>Device Control</v-card-title>
     <v-dialog v-model="dialog_confirmation" persistent max-width="40%">
      <Card>
       <v-card-title class="subheading">Are you sure to change the {{ d_Name }} device state?</v-card-title>
       <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" @click="dialog_confirmation = false">NO</v-btn>
        <v-btn color="success"
         v-on:click="apiDeviceStatus[selectedId] = !apiDeviceStatus[selectedId];  changeState(apic_ID,d_ID, d_Type,d_Name,apiDeviceStatus[selectedId]?'1':'0' ,d_Interface);dialog_confirmation = false">
         Yes</v-btn>
       </v-card-actions>
      </Card>
     </v-dialog>
     <v-dialog v-model="dialog_mqtterror" max-width="50%">
      <Card>
       <v-card-title class="subheading">
        <center>Sorry Connection Lost with Device</center>
       </v-card-title>
      </Card>
     </v-dialog>
     <v-dialog v-model="dialog_inCorrectPassword" max-width="50%">
      <Card>
       <v-card-title class="headline">
        <center>Username or Password entered is incorrect</center>
       </v-card-title>
      </Card>
     </v-dialog>
     <v-dialog v-model="dialog_password" max-width="30%">
      <Card class="pa-3">
       <v-card-title class="title pa-2 justify-center">Enter the Password </v-card-title>
       <v-divider></v-divider>
       <v-form class="pa-2">
        Email
        <v-text-field class="pa-0" v-model="user_id" data-vv-name="user_id"> </v-text-field>
        Password
        <v-text-field class="pa-0" type="password" v-model="password" data-vv-name="password" required>
        </v-text-field>
        <v-card-actions>
         <v-spacer></v-spacer>
         <v-btn color="error" @click="dialog_password = false">Reject</v-btn>
         <v-btn color="success" v-on:click="checkPassword(user_id,password);dialog_password = false">Submit
         </v-btn>
        </v-card-actions>
       </v-form>
      </Card>
     </v-dialog>
    </Card>
   </v-flex>
  </v-layout>
  <v-flex>
   <Card>
    <v-card-text v-for="n in deviceList" :key="n.deviceList">
     <v-btn :color="apiDeviceStatus[n.id] ? 'success':'error'" :key="compKey"
      @click.stop="compKey++;clickSpecificDevice(n)">{{ n.device_name }}
     </v-btn>
     Current status of {{ n.device_name }} is {{ apiDeviceStatus[n.id] ? 'ON':'OFF' }} <br>
    </v-card-text><br>
   </Card>
  </v-flex>
 </v-container>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import Controlling from '@/services/Controlling'
import moment from 'moment'
import Login from '@/services/login'
import { mapGettersMixin } from "@/util/mixin/index";

let mqtt = require('mqtt')

export default {
  mixins: [ mapGettersMixin ],
  // to display the data
  data () {
    return {
      info: 'to display data',
      count: null,
      apiData: {},
      deviceList: [],
      d_Name: '',
      d_Type: '',
      d_ID: '',
      d_State: {},
      apic_ID: '',
      d_Interface: '',
      checked: null,
      client: null,
      device_id: null,
      device_name: null,
      device_type: null,
      apiDeviceStatus: {},
      topicValue: null,
      msg: null,
      compKey: 0,
      dialog_confirmation: false,
      dialog_mqtterror: false,
      dialog_password: false,
      dialog_inCorrectPassword: false,
      confirmation: null,
      mqqttStatus: 0,
      selectedId: null,
      valid: true,
      loading: false,
      invalid: false,
      user_id: '',
      password: '',
      RememberMe: 'Remember me',
      passwordRules: [v => !!v || 'Password is required'],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || 'E-mail must be valid'
      ],
      model: {
        username: '',
        password: ''
      },
      timeout: ''
    }
  },

  mounted() {
    this.user_id = this.getUserInfo('email')
    this.client = mqtt.connect(
      process.env.VUE_APP_MQTT_URL, {
        username: 'test',
        password: 'test'
      })
    // connect to specific device as sub
    this.client.on('connect', function () {
      this.client.subscribe('control_p/#')
      // this.client.subscribe('control/disconnected')
      this.mqqttStatus = 1
      // this.client.subscribe(this.topicValue)
    }.bind(this))
    this.client.on('message', function (topic, message) {
      console.log('this.client.on(topic) : ' + topic)
      var context = message.toString()
      console.log('this.client.on(message) : ' + context)
      this.mqqttStatus = 1
      // console.log(' The Device State :', message.toString())
      // console.log(' server subscribe  :', topic.toString())

      let m = JSON.parse(message.toString())
      let device_name = m.device_name
      let status = m.status
      let [,,, deviceTyp] = topic.split('/')
      // let deviceTyp1 = topic.split('/').filter(item => item);
      console.log('server.subscribe : ' + deviceTyp)
      // console.log("server.subscribe( : "+deviceTyp1)
      if (deviceTyp === 'wms') {
        var [, plantId,, deviceType, blockId, deviceId] = topic.split('/')
      } else {
        var [, plantId,, deviceType, blockId, roomId, deviceId] = topic.split('/')
        console.log('Details :  ' + plantId, deviceType, blockId, roomId, deviceId)
      }
      console.log('Device Type :  ' + deviceTyp + 'data :  ' + plantId, deviceType, blockId, roomId, deviceId)
      let parm = { plantId: plantId, blockId: blockId, roomId: roomId, deviceId: deviceId, deviceTyp: deviceTyp, device_name: device_name, status: status }
      this.insertDevicestatus(parm)
    }.bind(this))

    this.client.on('error', function(error) {
      this.mqqttStatus = 0
      console.log('ERROR: ', error)
    })

    this.client.on('offline', function() {
      this.mqqttStatus = 0
      console.log('offline')
    })

    this.client.on('reconnect', function() {
      this.mqqttStatus = 0
      console.log('reconnect')
    })
    this.setIntervalWithoutDelay(this.callAllApi)
  },

  computed: {
    ...mapGetters(['getUserInfo', 'getSelectedPlantId'])
  },

  // to perform the operations
  methods: {
    ...mapMutations([
      'SET_LAST_CALL_TIME'
    ]),
    callAllApi() {
      let updateTime = moment().format('MM-DD-YYYY H:mm:ss')
      this.SET_LAST_CALL_TIME(updateTime)
      this.getData()
      this.getDevicestatus()
    },
    // call api to get cDeviceData
    async getData() {
      let response = await Controlling.controllableDeviceList(this.getSelectedPlantId)
      console.log('Status', response.status)
      if (response.status === 200) {
        this.apiData = response.data.message
        // console.log("response : "+JSON.stringify(this.apiData))
        response.data.message.forEach(element1 => {
          console.log('element : ', element1)
          let i = element1
          let dList = element1
          dList['device_id'] = (i['device_id'])
          dList['device_type'] = (i['device_type'])
          dList['device_name'] = (i['device_name'])
          dList.id = `${i.device_type}-${i.device_id}`
          this.deviceList.push(dList)
        })
      } else {
        console.log('No api data')
      }
    },

    // call api to get cDevicestatus
    async getDevicestatus() {
      console.log('api call For controllableDeviceStatus')
      let response = await Controlling.controllableDeviceDetails(this.getSelectedPlantId)
      console.log('Status', response.status)
      if (response.status === 200) {
        console.log('response : ' + response.data.message)
        // this.apiDeviceStatus = response.data.message
        response.data.message.forEach(item => {
          console.log('ITEM : ', item)
          this.apiDeviceStatus[`${item.device_type}-${item.device_id}`] = item.device_status ? 1 : 0
          this.compKey++
        })
      } else {
        console.log('No api data')
      }
    },

    // call api to insert Devicestatus
    async insertDevicestatus(parm) {
      this.mqqttStatus = 1
      console.log('api call For Inserting controllableDeviceStatus')
      let response = await Controlling.insertControllableDeviceDetails(parm)
      console.log('InsertDevicestatus Status : ')
      if (response.status === 200) {
        this.getDevicestatus()
        console.log(' Inserting controllableDeviceStatus response : ' + response.data.message + ' ' + this.apiDeviceStatus[this.selectedId])
        this.apiDeviceStatus[this.selectedId] = this.apiDeviceStatus[this.selectedId] === 1 ? 0 : 1
        alert('The device state was changed')
      } else {
        alert('The device state was not changed')
        console.log('No api data')
        console.log(' Inserting controllableDeviceStatus response : ', JSON.stringify(response))
      }
    },

    // Check userId and password
    checkPassword: async function(email, pass) {
      this.user_id = email
      this.password = pass

      console.log('response.email : ', email)
      console.log('response.email : ', pass)
      let response = await Login.validateUser({
        email: email,
        password: pass
      })
      // self.dialog = false
      console.log('response.status : ', response.status)
      console.log('response.status : ', response)
      if (response.status == 400) {
        let err = response.error
        console.log('response.status : ', response)
        this.snackbar = true
        this.snackbarMessage = 'Username or password entered is incorrect'
        this.dialog_inCorrectPassword = true
      }
      if (response.status === 200) {
        if (pass.length > 1) {
          if (this.mqqttStatus) { this.dialog_confirmation = true } else { this.dialog_mqtterror = true }
        } else {
          this.dialog_inCorrectPassword = true
        }
      }
      // if (this.$refs.form.validate()) {
      //   if (this.model.username === '' || this.model.password === '') {
      //        console.log('Invalid')
      //        return
      //   }
      //   // this.dialog = true
      //   // this.loading = true
      //   // this.buttonStatus = true
      //   // var self = this
      //   let response = Login.validateUser({
      //     email: this.model.username,
      //     password: this.model.password
      //   })
      //   // self.dialog = false
      //   if(response.status == 400){
      //     this.snackbar = true,
      //     this.snackbarMessage = 'Username or password entered is incorrect'
      //   }
      //   if (response.status === 200) {}
      // }
    },

    // button click fun
    clickSpecificDevice: function(n) {
      // this.dialog = true;
      // console.log('Button clicked  State : '+ apic_data,de_id,de_type,de_name,de_state,de_interface);
      this.d_Name = n.device_name
      this.apic_ID = n.apic_id
      this.d_ID = n.device_id
      this.d_Type = n.device_type
      this.d_State = this.apiDeviceStatus[n.id] ? 1 : 0
      this.d_Interface = n.device_interface
      this.selectedId = n.id
      if (this.mqqttStatus) { this.dialog_password = true } else { this.dialog_mqtterror = true }

      console.log('clickDeviceButton : ' + this.apic_ID, this.d_ID, this.d_Type, this.d_Name, this.d_State, this.d_Interface)
    },

    // button click fun
    changeState: function(apic_id, d_id, d_type, d_name, state, device_interface) {
      this.password = ''
      console.log('Button clicked')
      this.count = 'You clicked ' + d_name + ' and status is ' + state

      this.msg = '{ "plant_id": "' + this.getSelectedPlantId + '", "device_id": "' + d_id + '", "device_name": "' + d_name +
            '", "device_type": "' + d_type + '",  "status": "' + state + '", "device_interface":"' + device_interface + '" }'

      let blockPath = d_id.split('-').join('/')
      this.topicValue = 'control/' + this.getSelectedPlantId + '/' + apic_id + '/' + d_type + '/' + blockPath + ''
      // this.topicValue ='control/100/NEEHAD/'+d_type+'/'+blockPath+'';    //testing topic
      console.log('topic : ' + this.topicValue)
      console.log('MESSAGE : ' + this.msg)
      this.getDevicestatus()
      this.client.publish(this.topicValue, this.msg)
      // this.client.publish('check/online/CDeviceState', msg)
    },

    mqttInitialize () {
      var self = this
    }
  },

  watch: {
    isReload() {
      if (this.isReload) {
        this.setIntervalWithoutDelay(this.callAllApi)
      }
    }
  }

}

</script>

<style>

#content-holder {
  box-shadow: 7px 7px 20px black;
}
.container.fluid {
  background-color: transparent;
}

</style>